import {GET_ALL_RULES, GET_RULE} from 'actions/types'

export default function (state = {}, action) {
  switch (action.type) {
    case GET_ALL_RULES:
      return {
        ...state,
        ruleList: action.payload,
      }
    case GET_RULE:
      return {
        ...state,
        rule: action.payload,
      }

    default:
      return state
  }
}
